<template>
  <div>
    <div v-for="{id, publishTime, title, sortNum } in list" :key="id" class="news-line">
      <div v-if="title !== ''" class="hasContent">
        <div class="fr news-time">{{ publishTime }}</div>
        <div class="news-content">
          <span class="news-icon" />
          <svg v-if="sortNum" class="svg-up" xmlns="http://www.w3.org/2000/svg" width="12" height="15" viewBox="0 0 12 15">
            <path
              id="矩形_833"
              ta-name="矩形 833"
              class="cls-1"
              d="M876,763v7h-2v-7h-5l6-7,6,7h-5Zm-7-7v-1h12v1H869Z"
              transform="translate(-869 -755)" />
          </svg>
          <router-link
            :to="{name: 'HomeDetails', query: {id: id}}"
            target="_blank">{{ title }}
          </router-link>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  props: {
    listNumber: {
      type: Number,
      default: 10
    },
    propList: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      list: []
    }
  },
  watch: {
    propList() {
      this.initList()
    }
  },
  mounted() {
    this.initList()
  },
  methods: {
    initList() {
      // 补充空数据
      if (this.propList.length < this.listNumber) {
        const len = this.listNumber - this.propList.length
        this.list = [...this.propList]
        for (let i = 0.1; i < (len + 0.1); i += 1) {
          this.list.push({
            id: i,
            publishTime: '',
            title: ''
          })
        }
      } else { // 数据过多 截取数据
        this.list = this.propList.slice(0, this.listNumber)
      }
      this.list = this.list.map((item) => {
        if (item.publishTime) {
          item.publishTime = item.publishTime.substr(0, 10)
        }
        return item
      })
    }
  }
}
</script>

<style lang="scss" scoped>
  .news-line{
    display: block;
    width: 100%;
    height: 36px;
    line-height: 36px;
    color: #666;
    border-bottom: dashed 1px #ccc;
    .hasContent{
      height: 35px;
      &:hover {
        background-color: #f4f4f4;
      }
    }
    .news-content{
      display: inline-block;
      width: calc(95% - 95px);
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
      .news-icon{
        width:10px;
        height: 10px;
        display: inline-block;
        background: url('../../assets/images/list_point.png') no-repeat left;
        margin-right: 5px;
        line-height: 26px;
      }
    }
  }
  .news-time{
    font-family: 'Helvetica Neue';
    text-align: left;
  }
  .svg-up {
    width: 12px;
    height: 11px;
    margin-right: 4px;
    .cls-1 {
      fill: #ce3732;
      fill-rule: evenodd;
    }
  }
</style>
